import { BaseService } from "../baseService";
import { ActiveAntsPurchaseOrderAPIService } from "./activeAntsPurchaseOrderAPIService";
import { FileAPIService } from "../fileAPIService";
import { sanitiseParams } from "src/utils/sanitiser";
import { GetActiveAntsPurchaseOrdersQueryParams } from "src/types/api";

class ActiveAntsPurchaseOrderService extends BaseService<ActiveAntsPurchaseOrderAPIService> {
  private readonly fileAPIService: FileAPIService;

  constructor(apiService: ActiveAntsPurchaseOrderAPIService, fileAPIService: FileAPIService) {
    super(apiService);
    this.fileAPIService = fileAPIService;
  }

  @sanitiseParams()
  async getActiveAntsPurchaseOrders(queryParams: GetActiveAntsPurchaseOrdersQueryParams) {
    return await this.apiService.getActiveAntsPurchaseOrders(queryParams);
  }

  @sanitiseParams()
  async getActiveAntsPurchaseOrderById(activeAntsPurchaseOrderId: string) {
    return await this.apiService.getActiveAntsPurchaseOrderById(activeAntsPurchaseOrderId);
  }

  @sanitiseParams()
  async getActiveAntsPurchaseOrderPDF(activeAntsPurchaseOrderId: string): Promise<File> {
    const { url, fileName } = await this.apiService.getActiveAntsPurchaseOrderPDFUrl(activeAntsPurchaseOrderId);
    const fileBlob = await this.fileAPIService.getFile(url);
    return new File([fileBlob], fileName || `active-ants-purchase-order-${activeAntsPurchaseOrderId}.pdf`, {
      type: "application/pdf",
      lastModified: new Date().getTime()
    });
  }

  @sanitiseParams()
  async resolveAAError(
    activeAntsPurchaseOrderId: string,
    requestBody: {
      products: { productId: string; skuName?: string; barcode?: string; variantId?: string }[];
    }
  ) {
    return await this.apiService.resolveAAError(activeAntsPurchaseOrderId, requestBody);
  }
}

export { ActiveAntsPurchaseOrderService };
